function openTab(evt, tabName, tabWrapper) {
  const tabWrapperElement = document.getElementById(tabWrapper);
  const currentTabContent = tabWrapperElement.querySelector(
    `#${tabName}`
  );
  var isAlreadyOpen = (currentTabContent.style.display == 'block')
  // Hide all tab contents within the given tabWrapper
  const tabcontents = tabWrapperElement.querySelectorAll(
    '.main-product__tab-content'
  );
  tabcontents.forEach(content => {
    content.style.display = 'none';
  });

  // Remove 'active' class from all tab links within the given tabWrapper
  const tablinks = tabWrapperElement.querySelectorAll(
    '.main-product__tab'
  );
  tablinks.forEach(link => {
    link.classList.remove('active');
  });

  // Show the current tab and add the 'active' class to the button that opened the tab
  
  if (currentTabContent && !isAlreadyOpen) {
    currentTabContent.style.display = 'block';
    if (evt.currentTarget) {
      evt.currentTarget.classList.add('active');
    }
  }
}

document.addEventListener('DOMContentLoaded', function () {
  function simulateClick(element) {
    const event = new MouseEvent('click', {
      view: window,
      bubbles: true,
      cancelable: true
    });
    element.dispatchEvent(event);
  }

  // Get all the wrapper elements for each instance
  const tabWrappers = document.querySelectorAll(
    '.main-product__tabs-wrapper'
  );

  // Loop through each instance to find and click the default open tab
  tabWrappers.forEach(wrapper => {
    // get the wrapperID only if it exists
    const wrapperID = wrapper.getAttribute('id');
    if (!wrapperID) return;

    // get all the tabs marked as default open for every instance
    const defaultOpenTabs = wrapper.querySelectorAll(
      '.main-product__tab[data-default-open]'
    );

    // Loop through each default open tab and click it
    defaultOpenTabs.forEach(tabToClick => {
      simulateClick(tabToClick);
    });
  });
});

// var acc = document.getElementsByClassName("accordion");
// var i;

// for (i = 0; i < acc.length; i++) {
//   acc[i].addEventListener("click", function() {
//     /* Toggle between adding and removing the "active" class,
//     to highlight the button that controls the panel */
//     // this.classList.toggle("active");

//     /* Toggle between hiding and showing the active panel */
//     var panel = this.nextElementSibling;
//     if (panel.style.display === "block") {
//       panel.style.display = "none";
//     } else {
//       panel.style.display = "block";
//     }
//   });
// }
